import { useEffect } from "react";
import { useForm } from "react-hook-form";
import type { Shipment } from "@api/graphql/generated/generated-types";
import type { ManualArrivalFormData } from "../types";
import { buildManualArrivalFormDefaults } from "../utils/buildManualArrivalFormDefaults";

export function useManualArrivalForm(
  sortedStops: NonNullable<Shipment["stops"]>,
  isShipmentAssigned: boolean,
) {
  const { handleSubmit, control, reset, formState: { dirtyFields } } =
    useForm<ManualArrivalFormData>();

  useEffect(() => {
    if (!isShipmentAssigned) return;
    reset(buildManualArrivalFormDefaults(sortedStops));
  }, [isShipmentAssigned, sortedStops, reset]);

  return { control, handleSubmit, dirtyFields };
}
